import { render, staticRenderFns } from "./SPIFPPDF.vue?vue&type=template&id=d1cf4a9e"
import script from "./SPIFPPDF.vue?vue&type=script&lang=js"
export * from "./SPIFPPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports